import React from "react";

import { normalizeSearchString } from "src/common/utils/common";
import {
	FilteredNode,
	LocalizedNode
} from "src/modules/shared/form-explorer/types";
import { isLocalizedParentNode } from "src/modules/shared/form-explorer/utils";

export function useFilteredNodes(
	nodes: LocalizedNode[],
	hasLimitedAccess: boolean,
	query: string
): FilteredNode[] {
	return React.useMemo(
		() =>
			filterNodes(nodes, hasLimitedAccess, normalizeSearchString(query)),
		[nodes, hasLimitedAccess, query]
	);
}

export function filterNodes(
	nodes: LocalizedNode[],
	hasLimitedAccess: boolean,
	query: string
): FilteredNode[] {
	return nodes.map(node => {
		if (isLocalizedParentNode(node)) {
			// do not hide empty parent nodes if there is no query
			if (query === "" && node.children.length === 0) {
				return {
					...node,
					isVisible: true,
					children: node.children as FilteredNode[]
				};
			}
			const children = filterNodes(
				node.children,
				hasLimitedAccess,
				query === "" ||
					normalizeSearchString(node.value.title).includes(query)
					? ""
					: query
			);
			const isVisible = children.some(child => child.isVisible);
			return { ...node, isVisible, children };
		} else {
			const isVisible =
				(hasLimitedAccess || !node.value.isLimitedAccess) &&
				(query === "" ||
					normalizeSearchString(node.value.title).includes(query));
			return { ...node, isVisible };
		}
	});
}
